<div class="list-search-container">
  <div class="list-search">
    <input
      #searchInput
      matInput
      autocomplete="off"
      spellcheck="false"
      [formControl]="searchControl"
      [placeholder]="TranslationKeys.FilterTypeSearch | translate"
      (blur)="searchInput.focus()"
    />
    @if (searchControl?.value?.length) {
      <i (click)="onRemoveSearch()" [nimbusIcon]="ICONS.CLOSE_LIGHT"></i>
    }
  </div>
</div>
<hr />
@if (options$ | async; as availableOptions) {
  <div class="list">
    @if (hasSelection || availableOptions?.length) {
      <button nimbusPrimaryNoBorderButton class="nimbus-filter-control-button" (click)="toggleSelection(availableOptions)">
        <nimbus-input-check-box [checked]="hasSelection"></nimbus-input-check-box>
        <span class="selection-control-name">{{
          (hasSelection ? TranslationKeys.FilterClearSelection : TranslationKeys.FilterSelectAll) | translate
        }}</span>
      </button>
    }
    @if (selection?.length) {
      <div class="selection-list">
        @for (selectedOption of selection; track trackByFn($index, selectedOption)) {
          <nimbus-nimbus-filter-select-list-item
            [selected]="selectedOptionsLookup[selectedOption.id]"
            (filterSelect)="onFilterSelect($event)"
            [option]="selectedOption"
          ></nimbus-nimbus-filter-select-list-item>
        }
        <hr />
      </div>
    }
    <div class="available-list">
      @if (searchControl?.value?.length && !availableOptions?.length) {
        <span class="no-records-filter">{{ TranslationKeys.GeneralGridNoRecords | translate }}</span>
      }
      @for (option of availableOptions; track trackByFn($index, option)) {
        <nimbus-nimbus-filter-select-list-item
          [selected]="selectedOptionsLookup[option.id]"
          (filterSelect)="onFilterSelect($event)"
          [option]="option"
        ></nimbus-nimbus-filter-select-list-item>
      }
    </div>
  </div>
}
